export const fromLargeMediaQuery = '(min-width: 891px)';
export const untilLargeMediaQuery = '(max-width: 890px)';
